<template>
  <ListItem :to="{ name: 'infringementDetail', params: { id: infringement.id } }">
    <div class="flex basis-[20%] items-center gap-2">
      <InfringementStatusBadge :status="infringement.status" size="sm" />
      <Spinner v-if="showLoadingSpinner" class="size-4 animate-spin text-primary" />
      <Information v-if="errorSteps.length && infringement.status !== InfringementStatus.COMPLETED">
        <template #trigger>
          <CircleXIcon class="size-4 text-bittersweet-600" />
        </template>
        <template #modal>
          <div v-for="step in errorSteps" :key="step">
            {{ t(`infringementSteps.${step}`) }}
          </div>
        </template>
      </Information>
    </div>

    <div class="basis-[10%]">
      <div v-if="infringement.data">
        <LicencePlate>{{ infringement.data.licencePlate }}</LicencePlate>
      </div>
    </div>

    <div class="basis-[15%]">
      <p v-if="infringement.data" class="text-black">{{ infringement.data.fileNumber }}</p>
    </div>

    <div class="basis-[40%]">
      <div v-if="infringement.data">
        <span>{{ t(`infringementTypes.${infringement.data.infringementType}`) }}</span>
        {{ t('at') }}
        <span>{{ formatDate(infringement.data.date) }}</span>
      </div>
    </div>

    <div class="basis-[15%] text-right">
      <p class="text-xs text-obsidian-500">{{ formatDate(infringement.createdDate) }}</p>
    </div>
  </ListItem>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import ListItem from '@/components/ListItem.vue';
import { InfringementStatus, type Infringement } from '@carvia/ros-client-types';
import InfringementStatusBadge from '@/components/badges/InfringementStatusBadge.vue';
import { formatDate } from '@/hooks/use-formatted-date';
import LicencePlate from '@/components/LicencePlate.vue';
import Information from '@/components/Information.vue';
import { AlertTriangleIcon, CircleXIcon } from 'lucide-vue-next';
import { useInfringementStepState } from '@/hooks/use-infringement-step-state';

const props = defineProps<{
  infringement: Infringement;
}>();

const { t } = useI18n();
const { errorSteps, showLoadingSpinner } = useInfringementStepState(() => props.infringement);
</script>

<i18n lang="json">
{
  "en": {
    "at": "at"
  },
  "de": {
    "at": "am"
  },
  "es": {
    "at": "a las"
  }
}
</i18n>
